<template>
    <div>
        <b-row>
            <b-col>
                <div class="d-flex mb-3">
                    <b-button v-if="checkPermission('fulfillment')" href="#fulfillment"class="mx-1" variant="primary" size="lg">
                        <i class="fa-solid fa-print mr-2"></i>Fulfillment</b-button>
                    <b-button v-if="checkPermission('todays-appraisal')" href="#appraisals" class="mx-1" variant="primary" size="lg">
                        <i class="fa-solid fa-box-full mr-2"></i>Appraisal</b-button>
                    <b-button href="#qa" v-if="checkPermission('todays-qa&offer-gen')" class="mx-1" variant="primary" size="lg">
                        <i class="fa-solid fa-file-check mr-2"></i>QA</b-button>
                    <b-button href="#qa" v-if="checkPermission('todays-qa&offer-gen')" class="mx-1" variant="primary" size="lg">
                        <i class="fa-solid fa-file-check mr-2"></i>Offers</b-button>
                    <b-button v-if="checkPermission('total-in-payments')" href="#payments" class="mx-1" variant="primary" size="lg">
                        <i class="fa-solid fa-money-bill-alt mr-2"></i>Payments</b-button>

                    <b-button href="#returns" v-if="checkPermission('returns-today')" class="mx-1" variant="primary" size="lg">
                        <i class="fa-solid fa-share mr-2"></i>Returns</b-button>
                    <b-button v-if="checkPermission(['flags-general', 'flags-return', 'flags-customer-service','flags-compliance', 'flags-processing', 'flags-return'])" href="#flags" class="mx-1" variant="primary" size="lg">
                        <i class="fa-solid fa-flag mr-2"></i>Flags</b-button>

                    <b-button v-if="checkPermission(['processing-order-by-agent', 'processing-inventory-by-agent', 'processing-pieces-by-agent', 'processing-errors-by-agent'])" href="#processing" class="mx-1" variant="primary" size="lg">
                        <i class="fa-solid fa-clock mr-2"></i>Processing</b-button>
                </div>
            </b-col>
        </b-row>


        <!--General-->
        <b-card v-if="checkPermission([
                'conversion-1',
                'campaign-penetration-percent',
                'calls-per-campaign',
                'abandons-by-group',
                'fulfillment',
                'package-intake',
                'todays-appraisal',
                'todays-appraisal-mtd',
                'todays-qa&offer-gen',
                'total-qa&offer-gen',
                'today-offer-result',
                'total-in-payments',
                'payment-statuses',
                'returns-today',
                'returns-of-returns-today'])">



            <div class="d-flex flex-wrap" ref="generalWidgetWrapper">
                <!--five9-->
                <CallsPerCampaignPenitration :width="generalWidgetWidth"  dataDisplay="text" v-if="checkPermission('campaign-penetration-percent')"></CallsPerCampaignPenitration>
                <CallsPerCampaign :width="generalWidgetWidth"  dataDisplay="text" v-if="checkPermission('calls-per-campaign')"></CallsPerCampaign>
                <AbandonRateByGroup :width="generalWidgetWidth"  dataDisplay="text" v-if="checkPermission('abandons-by-group')"></AbandonRateByGroup>


                <!--fulfillment-->
                <OrdersToFulfilToDate :width="generalWidgetWidth"  dataDisplay="text" id="fulfillment" v-if="checkPermission('fulfillment')"></OrdersToFulfilToDate>
                <PackageIntake  :width="generalWidgetWidth"  dataDisplay="text" v-if="checkPermission('package-intake')"></PackageIntake>

                <!--appraisal-->
                <TodaysAppraisalStatusFromKitReceived :width="generalWidgetWidth"  dataDisplay="text" id="appraisals" v-if="checkPermission('todays-appraisal')"></TodaysAppraisalStatusFromKitReceived>
                <TodaysAppraisalStatusTotal :width="generalWidgetWidth"  dataDisplay="text" v-if="checkPermission('todays-appraisal-mtd')"></TodaysAppraisalStatusTotal>

                <!--QA-->
                <TodaysQAAndOfferGenerationFromKitReceived :width="generalWidgetWidth"  dataDisplay="text" id="qa" v-if="checkPermission('todays-qa&offer-gen')"></TodaysQAAndOfferGenerationFromKitReceived>
                <TodaysQAAndOfferGenerationTotal :width="generalWidgetWidth"  dataDisplay="text" v-if="checkPermission('total-qa&offer-gen')"></TodaysQAAndOfferGenerationTotal>
                <TodaysOfferResults :width="generalWidgetWidth"  dataDisplay="text" v-if="checkPermission('today-offer-result')"></TodaysOfferResults>

                <!--payments-->
                <TotalPaymentsOrderHistory :width="generalWidgetWidth"  dataDisplay="text" id="payments" v-if="checkPermission('total-in-payments')"></TotalPaymentsOrderHistory>
                <TotalPaymentsReady :width="generalWidgetWidth"  dataDisplay="text" v-if="checkPermission('payment-statuses')"></TotalPaymentsReady>

                <!--returns-->
                <TodaysReturnsStatus :width="generalWidgetWidth"  dataDisplay="text" id="returns" v-if="checkPermission('returns-today')"></TodaysReturnsStatus>
                <TodaysReturnsOfReturnsStatus :width="generalWidgetWidth"  dataDisplay="text" v-if="checkPermission('returns-of-returns-today')"></TodaysReturnsOfReturnsStatus>
                <CurrentPaidGoods :width="generalWidgetWidth"  dataDisplay="text" v-if="checkPermission('total-in-payments')"></CurrentPaidGoods>
                <CurrentSettledGoods :width="generalWidgetWidth"  dataDisplay="text" v-if="checkPermission('total-in-payments')"></CurrentSettledGoods>
            </div>
        </b-card>






        <!--Flags-->
        <div class="hash-link" id="flags"></div>
        <b-card class="mt-5">
            <template v-slot:header>
                <span class="h4"><i class="fa-solid mr-2 fa-flag"></i>Flags</span>
            </template>

            <div class="d-flex flex-wrap">
                <ComplianceFlags  v-bind:width=100  dataDisplay="text"  v-if="checkPermission('flags-compliance')"></ComplianceFlags>

                <div ref="flagWidgetWrapper" class="d-flex flex-wrap w-100">
                    <CustomerServiceFlags :width="flagWidgetWidth"  dataDisplay="text" v-if="checkPermission('flags-customer-service')"></CustomerServiceFlags>
                    <GeneralFlags :width="flagWidgetWidth"  dataDisplay="text" v-if="checkPermission('flags-general')"></GeneralFlags>
                    <PaymentIssueFlags :width="flagWidgetWidth" dataDisplay="text" v-if="checkPermission('flags-payment')"></PaymentIssueFlags>
                    <ProcessingFlags :width="flagWidgetWidth"  dataDisplay="text" v-if="checkPermission('flags-processing')"></ProcessingFlags>
                    <ReturnFlags :width="flagWidgetWidth" dataDisplay="text"  v-if="checkPermission('flags-return')"></ReturnFlags>
                </div>
            </div>
        </b-card>







        <!-- Processing -->
        <span id="processing" class="hash-link"></span>
        <b-card class="mt-5" v-if="checkPermission(['processing-order-by-agent', 'processing-inventory-by-agent', 'processing-pieces-by-agent', 'processing-errors-by-agent'])">
            <template v-slot:header>
                <span class="h4"><i class="fa-solid mr-2 fa-clock"></i>Processing</span>
            </template>

            <div class="d-flex flex-wrap">
                <TodaysOrderesProcessedByHour  dataDisplay="text" v-if="checkPermission('processing-order-by-agent')"></TodaysOrderesProcessedByHour>
                <TodaysInventoryProcessedByHour  dataDisplay="text" v-if="checkPermission('processing-inventory-by-agent')"></TodaysInventoryProcessedByHour>
                <TodaysInventoryPiecesProcessedByHour  dataDisplay="text" v-if="checkPermission('processing-pieces-by-agent')"></TodaysInventoryPiecesProcessedByHour>
                <ProcessingErrorsByAgent  dataDisplay="text" v-if="checkPermission('processing-errors-by-agent')"></ProcessingErrorsByAgent>
            </div>
        </b-card>










    </div>
</template>

<script>
    /* new leads */
    import NewLeads from './data/leads/NewLeads';

    /* five9 */
    import UserByCallBase from './data/five9/UserByCallBase';
    import CallsPerCampaignPenitration from './data/five9/CallsPerCampaignPenitration';
    import CallsPerCampaign from './data/five9/CallsPerCampaign';
    import AbandonRateByGroup from './data/five9/AbandonRateByGroup';
    import QuotesEntered from './data/five9/QuotesEntered';

    /* fulfillment */
    import OrdersToFulfilToDate from './data/fulfillment/OrdersToFulfilToDate';
    import PackageIntake from './data/fulfillment/PackageIntake';

    /* Appraisal */
    import TodaysAppraisalStatusFromKitReceived from './data/appraisals/TodaysAppraisalStatusFromKitReceived';
    import TodaysAppraisalStatusTotal from './data/appraisals/TodaysAppraisalStatusTotal';

    /* Quality Assurance & Offers */
    import TodaysQAAndOfferGenerationFromKitReceived from './data/QA-offers/TodaysQAAndOfferGenerationFromKitReceived';
    import TodaysQAAndOfferGenerationTotal from './data/QA-offers/TodaysQAAndOfferGenerationTotal';
    import TodaysOfferResults from './data/QA-offers/TodaysOfferResults';

    /* Payments */
    import TotalPaymentsOrderHistory from './data/payments/TotalPaymentsOrderHistory';
    import TotalPaymentsReady from './data/payments/TotalPaymentsReady';
    import CurrentPaidGoods from './data/payments/CurrentPaidGoods';
    import CurrentSettledGoods from './data/payments/CurrentSettledGoods';

    /* Returns */
    import TodaysReturnsOfReturnsStatus from './data/returns/TodaysReturnOfReturnsStatus';
    import TodaysReturnsStatus from './data/returns/TodaysReturnStatus';

    /* Flags */
    import ProcessingFlags from './data/flags/ProcessingFlags';
    import GeneralFlags from './data/flags/GeneralFlags';
    import ComplianceFlags from './data/flags/ComplianceFlags';
    import ReturnFlags from './data/flags/ReturnFlags';
    import CustomerServiceFlags from './data/flags/CustomerServiceFlags';
    import PaymentIssueFlags from './data/flags/PaymentIssueFlags'

    /* Processing */
    import InventoryProcessedL2PChart from './data/processing/InventoryProcessedL2PChart';
    import InventoryPiecesProcessedL2PChart from './data/processing/InventoyPiecesProcessedL2PChart';
    import OrdersProcessedL2PChart from './data/processing/OrderProcessedL2PChart';
    import TodaysOrderesProcessedByHour from './data/processing/TodaysOrdersProcessedByHour';
    import TodaysInventoryProcessedByHour from './data/processing/TodaysInventoryProcessedByHour';
    import TodaysInventoryPiecesProcessedByHour from './data/processing/TodaysInventoryPiecesProcessedByHour';
    import AvgInventoryPiecesProceseedByHour from './data/processing/AvgInventoryPiecesProcessedByHour';
    import ProcessingErrorsByAgent from './data/processing/ProcessingErrorsByAgent';


    export default {
        name: 'dashboard-index',
        title: 'Dashboard',
        components: {
            UserByCallBase,
            CallsPerCampaignPenitration,
            CallsPerCampaign,
            QuotesEntered,
            AbandonRateByGroup,
            NewLeads,
            ProcessingErrorsByAgent,
            AvgInventoryPiecesProceseedByHour,
            TotalPaymentsReady,
            TotalPaymentsOrderHistory,
            TodaysInventoryPiecesProcessedByHour,
            TodaysInventoryProcessedByHour,
            TodaysOrderesProcessedByHour,
            OrdersProcessedL2PChart,
            InventoryPiecesProcessedL2PChart,
            CustomerServiceFlags,
            ReturnFlags,
            ComplianceFlags,
            GeneralFlags,
            PaymentIssueFlags,
            ProcessingFlags,
            TodaysReturnsStatus,
            TodaysReturnsOfReturnsStatus,
            TodaysQAAndOfferGenerationFromKitReceived,
            TodaysQAAndOfferGenerationTotal,
            PackageIntake,
            OrdersToFulfilToDate,
            TodaysAppraisalStatusFromKitReceived,
            TodaysAppraisalStatusTotal,
            TodaysOfferResults,
            InventoryProcessedL2PChart,
            CurrentPaidGoods,
            CurrentSettledGoods,
//            UrlDigitalAdminLayout,
//            DashboardGraph
            // ScaleWeight,
        },
        data() {
            return {
                generalWidgetCount: null,
                generalWidgetWidth: 25,
                flagWidgetWidth: 25,
                permissions: [],
                temp_permissions: ['Fulfillment Admin', 'Operations Admin', 'B79 Admin', 'Processing Admin', 'CS Admin'],
                bgColors: {
                    appraisals: '#ddd',
                }
            };
        },
        beforeMount(){
            var _this = this;
            this.$http.get('/roles/byUser').then(function (result) {
                _this.permissions = result.data;
                _this.$forceUpdate();
            });
        },
        mounted() {
            this.setGeneralWidgetWidth();
            this.setFlagWidgetWidth();
        },
        computed: {
            isPermLoaded: function () {
                return this.permissions != [];
            },


        },

        methods: {
            setGeneralWidgetWidth: function () {
                this.widgetCount = this.$refs.generalWidgetWrapper.childElementCount;
                if(this.widgetCount == 5 || this.widgetCount == 6 || this.widgetCount == 9 ) {
                    this.generalWidgetWidth = 33;
                }
            },
            setFlagWidgetWidth: function () {
                var flagWidgetCount = this.$refs.flagWidgetWrapper.childElementCount;
                if(flagWidgetCount == 5) {
                    this.flagWidgetWidth = 33;
                }
            },
            checkPermission: function (perm) {
                if (perm instanceof Array) {
                    for(let i = 0; i < perm.length; i++) {
                        if (this.$store.getters.hasDashboardAccess(perm[i])) {
                            return true;
                        }
                    }
                    return false;
                }
                return this.$store.getters.hasDashboardAccess(perm);
            }
        }
    };
</script>

<style scoped>
    .hash-link {
        position: relative;
        top: -80px;
    }

</style>
